import { ShowContextProvider, Title, useEditController } from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { CategoryChip } from "../../components/CategoryChip";
import { colors } from "../../data/tokens";

// Visualização no padrão de leitura das demais telas: nome em destaque
// com o chip colorido da categoria e o ID copiável.
export const UserCategoryShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "user-categories/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Categorias de Sócios" />
      <PageTopBreadcrumb
        title="Categoria de Sócios"
        firstPath="/#/user-categories/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: 17,
                  fontWeight: 700,
                  color: colors.primaryDark,
                }}
              >
                Categoria de Sócios
              </Typography>
              <CategoryChip name={record.name} />
            </Box>

            <Divider sx={{ marginY: 2.5 }} />

            <Typography sx={{ fontSize: 12, color: colors.textMuted }}>
              Identificador técnico
            </Typography>
            <Box sx={{ marginTop: 0.5 }}>
              <IdChip value={record.id} />
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
